import React from 'react';
import { useAlertContext } from '../../../../contexts/AlertContext/useAlertContext';
import useUserContext from '../../../../contexts/UserContext/useUserContext';
import ResetPasswordForm from './ResetPasswordForm';

const ResetPassword: React.FC = () => {
     const { resetPassword } = useUserContext();
     const { setAlert } = useAlertContext?.() || { setAlert: () => {} };

     const handleReset = async (email: string) => {
          const error = await resetPassword(email);
          if (typeof error === 'string' && setAlert) {
               setAlert({ open: true, message: error, severity: 'error' });
          } else if (setAlert) {
               setAlert({ open: true, message: 'E-mail de redefinição enviado!', severity: 'success' });
          }
     };

     return <ResetPasswordForm onSubmit={handleReset} />;
};

export default ResetPassword;
